export default __webpack_public_path__ + "static/media/S-037.4b3b7129.png";